import { toast } from 'react-toastify';
import { useCallback } from 'react';

import { ApiError } from '@/models/apiError';
import {
  BillingStatus,
  CheckoutSessionFormData,
  ReactivationStatus,
} from '@/models/stripe';
import api from '@/shared/api';
import { API_ERRORS, ENDPOINTS } from '@/shared/constants';

export default function useStripeApi() {

  const getBillingStatus = useCallback(async function getBillingStatus() {
    try {
      const response = await api.get<BillingStatus>(
        ENDPOINTS.STRIPE.GET.BILLING_STATUS
      )
      return response.data
    } catch {
      return false
    }
  }, [])

  async function createCheckoutSession(data: CheckoutSessionFormData) {
    try {
      const response = await api.post(ENDPOINTS.STRIPE.POST.CHECKOUT_SESSION, data);
      toast.success('Link criado');
      return response.data;
    } catch (error) {
      const apiError = error as ApiError;
      handleSaveError(apiError.response?.data?.errorCode);
      return false;
    }
  }


  async function createCustomerPortal() {
    try {
      const response = await api.post(ENDPOINTS.STRIPE.POST.CUSTOMER_PORTAL);
      return response.data;
    } catch {
      toast.error('Erro ao conectar ao Stripe');
      return false;
    }
  }

  async function createPlanChange(planId: number) {
    try {
      const response = await api.post<{ url: string }>(
        ENDPOINTS.STRIPE.POST.PLAN_CHANGE,
        { planId }
      )
      return response.data
    } catch {
      toast.error('Não foi possível iniciar a troca de plano')
      return false
    }
  }

  async function getReactivationStatus() {
    try {
      const response = await api.get<ReactivationStatus>(
        ENDPOINTS.STRIPE.GET.REACTIVATION_STATUS
      )
      return response.data
    } catch {
      toast.error('Erro ao consultar a reativação')
      return false
    }
  }

  async function createReactivationCheckout(planId: number) {
    try {
      const response = await api.post<{ url: string }>(
        ENDPOINTS.STRIPE.POST.REACTIVATION_CHECKOUT,
        { planId }
      )
      return response.data
    } catch {
      toast.error('Não foi possível iniciar a reativação')
      return false
    }
  }

  async function cancelReactivationCheckout() {
    try {
      await api.post(ENDPOINTS.STRIPE.POST.CANCEL_REACTIVATION_CHECKOUT)
      return true
    } catch {
      toast.error('Não foi possível cancelar o checkout')
      return false
    }
  }

  function handleSaveError(errorCode?: number) {
    if (errorCode && API_ERRORS[errorCode]) {
      toast.error(API_ERRORS[errorCode]);
    } else {
      toast.error('Erro ao conectar ao Stripe');
    }
  }

  return {
    createCheckoutSession,
    getBillingStatus,
    createCustomerPortal,
    createPlanChange,
    getReactivationStatus,
    createReactivationCheckout,
    cancelReactivationCheckout,
  };
}
